import { BOOLEAN_FIELD_TYPE, TEXT_FIELD_TYPE } from "../../../../helpers/constants";
import i18n from "../../../../i18n";
import ModeEditOutlineOutlined from "@mui/icons-material/ModeEditOutlineOutlined";
import SelectFieldService from "../../../../services/selectFieldService";


export const EXTERNAL_OWNER_TABLE_CONFIG = [
  {
    name: "owner_full_name",
    getValueCallback: (rowData) => rowData.owner_full_name,
    label: i18n.t("table.external_owner_table.owner_full_name"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    sortable: true,
    allowChangeVisibility: false,
  },
  {
    name: "owner_short_name",
    getValueCallback: (rowData) => rowData.owner_short_name,
    label: i18n.t("table.external_owner_table.owner_short_name"),
    filterType: TEXT_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    sortable: true,
  },
  {
    name: "owner_active",
    getValueCallback: (rowData) =>
      SelectFieldService.getLabelOptionsTrueOrFalse(rowData.owner_active),
    label: i18n.t("table.external_owner_table.owner_active"),
    filterType: BOOLEAN_FIELD_TYPE,
    getFilterFieldConfigCallback: (filteringData) => undefined,
  },
  {
    name: "edit",
    getValueCallback: (rowData, onClickEdit) => {
      return (
        <ModeEditOutlineOutlined
          onClick={(e) => onClickEdit(e, rowData.id)}
        />
      );
    },

    filterType: null,
    getFilterFieldConfigCallback: (filteringData) => undefined,
    excludedFromExport: true,
  }
];
